import { render, staticRenderFns } from "./customInput.vue?vue&type=template&id=801379fe&scoped=true&"
import script from "./customInput.vue?vue&type=script&lang=js&"
export * from "./customInput.vue?vue&type=script&lang=js&"
import style0 from "./customInput.vue?vue&type=style&index=0&id=801379fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "801379fe",
  null
  
)

export default component.exports